import {FC, useState, createContext, useContext, useMemo} from 'react'
import {
  ID,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  initialListView,
  ListViewContextProps,
  groupingOnSelectAll,
  WithChildren,
} from '../../../../../_metronic/helpers'
import {useDLMLabelSetsQueryResponse, useDLMLabelSetsQueryResponseData} from './DLMLabelSetsQueryResponseProvider'

const DLMLabelSetsListViewContext = createContext<ListViewContextProps>(initialListView)

const DLMLabelSetsListViewProvider: FC<WithChildren> = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)
  const [itemIdForDelete, setItemIdForDelete] = useState<ID>(initialListView.itemIdForDelete)
  const {isLoading} = useDLMLabelSetsQueryResponse()
  const data = useDLMLabelSetsQueryResponseData()
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

  return (
    <DLMLabelSetsListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        itemIdForDelete,        
        setItemIdForUpdate,
        setItemIdForDelete,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAll(isAllSelected, setSelected, data)
        },
        clearSelected: () => {
          setSelected([])
        },
      }}
    >
      {children}
    </DLMLabelSetsListViewContext.Provider>
  )
}

const useDLMLabelSetsListView = () => useContext(DLMLabelSetsListViewContext)

export {DLMLabelSetsListViewProvider, useDLMLabelSetsListView}
